import React from 'react';
function PromoCode({ size }) {
  return (
    <svg height={size} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.84zM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8z"
      ></path>
    </svg>
  );
}

export default PromoCode;
